import {
    AUTHENTICATING_SALESFORCE_SANDBOX_REQUEST, AUTHENTICATING_SALESFORCE_SANDBOX_SUCCEDDED, AUTHENTICATING_SALESFORCE_SANDBOX_FAILED,
    UPDATING_SALESFORCE_SANDBOX_REQUEST, UPDATING_SALESFORCE_SANDBOX_SUCCEDDED, UPDATING_SALESFORCE_SANDBOX_FAILED,
    FETCHING_SALESFORCE_SANDBOX_INTEGRATION_REQUEST, FETCHING_SALESFORCE_SANDBOX_INTEGRATION_SUCCEDDED, FETCHING_SALESFORCE_SANDBOX_INTEGRATION_FAILED,
  DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_REQUEST, DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_SUCCEDDED, DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_FAILED,
  CHANGING_PRIMARY_CONFIGURATION, CHANGING_PRIMARY_CONFIGURATION_FAILED,CHANGING_PRIMARY_CONFIGURATION_SUCCEEDED, OVERIDING_PRIMARY_EVENTS, OVERIDING_PRIMARY_EVENTS_SUCCEEDED, OVERIDING_PRIMARY_EVENTS_FAILED, FETCHING_TOTAL_SALESFORCE_INTEGRATIONS, FETCHING_TOTAL_SALESFORCE_INTEGRATIONS_SUCCEEDED, FETCHING_TOTAL_SALESFORCE_INTEGRATIONS_FAILED
} from '../actionTypes.jsx';
import { activatingIntegrationSuccedded,fetchingIntegrationSuccedded, deactivatingIntegrationSuccedded, 
  integrationAuthExpired } from '../integrations.jsx';
import axios from 'axios';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const SALESFORCE_BASE_URL = `${apiUrl}/api/2.0/integrations/salesforce`
const SALESFORCE_BASE_URL_V2 = `${apiUrl}/api/2.0/integrations/salesforce-sandbox`;

export function authenticateAccount(code){
  return function (dispatch) {
    dispatch(authenticatingAccount());

    const data = {
      code: code
    }

    return axios({
      method: 'POST',
      url: SALESFORCE_BASE_URL_V2,
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      params: data
    })
    .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(authenticatingAccountFailed(error.errors))
    )
  }
}
  
function authenticatingAccount(){
  return {
    type: AUTHENTICATING_SALESFORCE_SANDBOX_REQUEST,
    payload: {}
  }
}

function authenticatingAccountSuccedded(json){
  return {
    type: AUTHENTICATING_SALESFORCE_SANDBOX_SUCCEDDED,
    payload: json
  }
}

function authenticatingAccountFailed(error){
  return {
    type: AUTHENTICATING_SALESFORCE_SANDBOX_FAILED,
    payload: error
  }
}

// authenticating secondary account

export function authenticateSecondaryAccount(code, id){
  return function (dispatch) {
    dispatch(authenticatingAccount());
    const data = {
      code: code
    }

    return axios({
      method: 'POST',
      url: `${ SALESFORCE_BASE_URL_V2 }/${id}/override/change_user`,
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      params: data
    })
    .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
      dispatch(fetchingSalesforceIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(authenticatingAccountFailed(error.errors))
    )
  }
}

/**
* Update salesforce configuration
*/
export function updateConfiguration(configuration){
  return function (dispatch) {
    dispatch(updatingConfiguration());

    return axios({
      method: 'PUT',
      url: SALESFORCE_BASE_URL_V2,
      data: configuration
    })
    .then((response) => {
      dispatch(updatingConfigurationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error => {
      dispatch(integrationAuthExpired(error.errors, 'salesforce_v2'));
      dispatch(updatingConfigurationFailed(error.errors))
    })
  }
}

function updatingConfiguration(){
  return {
    type: UPDATING_SALESFORCE_SANDBOX_REQUEST,
    payload: {}
  }
}

function updatingConfigurationSuccedded(json){
  return {
    type: UPDATING_SALESFORCE_SANDBOX_SUCCEDDED,
    payload: json
  }
}

function updatingConfigurationFailed(error){
  return {
    type: UPDATING_SALESFORCE_SANDBOX_FAILED,
    payload: error
  }
}

/**
* Fetch salesforce integration
*/
export function fetchSalesforceIntegration() {
  return function (dispatch) {
    dispatch(fetchingSalesforceIntegration());

    return axios({
      method: 'GET',
      url: SALESFORCE_BASE_URL_V2
    })
    .then((response) => {
      dispatch(fetchingSalesforceIntegrationSuccedded(response.data));
      dispatch(fetchingIntegrationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(fetchingSalesforceIntegrationFailed(error.errors))
    )
  }
}

function fetchingSalesforceIntegration() {
  return {
    type: FETCHING_SALESFORCE_SANDBOX_INTEGRATION_REQUEST,
    payload: {}
  }
}

function fetchingSalesforceIntegrationSuccedded(json) {
  return {
    type: FETCHING_SALESFORCE_SANDBOX_INTEGRATION_SUCCEDDED,
    payload: json
  }
}

function fetchingSalesforceIntegrationFailed(error) {
  return {
    type: FETCHING_SALESFORCE_SANDBOX_INTEGRATION_FAILED,
    payload: error
  }
}


export function deactivateSalesforceIntegration(integrationType){
  return function (dispatch) {
    dispatch(deactivatingSalesforceIntegration());
    return axios({
      method: 'DELETE',
      url: SALESFORCE_BASE_URL_V2,
      params: {type: 'user'}
    })

    .then((response) => {
      dispatch(deactivatingSalesforceIntegrationSuccedded({type: integrationType,data:response.data}));
      dispatch(deactivatingIntegrationSuccedded({type: integrationType,data:response.data}));
    })
    .catch(error =>
      dispatch(deactivatingSalesforceIntegrationFailed(error.errors))
    )
  }
}

function deactivatingSalesforceIntegration(){
  return {
    type: DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_REQUEST,
    payload: {}
  }
}

function deactivatingSalesforceIntegrationSuccedded(json){
  return {
    type: DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_SUCCEDDED,
    payload: json
  }
}

function deactivatingSalesforceIntegrationFailed(error){
  return {
    type: DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_FAILED,
    payload: error
  }
}

export function changePrimaryConfiguration(id, code) {
  return function (dispatch) {
    dispatch(changingPrimaryConfiguration());
    return axios({
      method: 'POST',
      url: `${SALESFORCE_BASE_URL_V2}/${id}/change_user`,
      params: { code }
    })

      .then((response) => {
        dispatch(changingPrimaryConfigurationSuccedded(response.data));
        dispatch(activatingIntegrationSuccedded(response.data));

      })
      .catch(error => {
        dispatch(changingPrimaryConfigurationFailed(error.errors))
      }
      )
  }
}

function changingPrimaryConfiguration() {
  return {
    type: CHANGING_PRIMARY_CONFIGURATION,
    payload: {}
  }
}

function changingPrimaryConfigurationSuccedded(json) {
  return {
    type: CHANGING_PRIMARY_CONFIGURATION_SUCCEEDED,
    payload: json
  }
}

function changingPrimaryConfigurationFailed(error) {
  return {
    type: CHANGING_PRIMARY_CONFIGURATION_FAILED,
    payload: error
  }
}

export function updatePrimaryEventsOverride(configuration) {
  const { integrationId } = configuration;
  return function (dispatch) {
    dispatch(updatingPrimaryEventsOverride());
    return axios({
      method: 'PUT',
      url: `${SALESFORCE_BASE_URL_V2}/${integrationId}/override`,
      data: configuration
    })

      .then((response) => {
        dispatch(updatingPrimaryEventsOverrideSucceeded(response.data));
        dispatch(fetchingSalesforceIntegrationSuccedded(response.data));
      })
      .catch(error => {
        dispatch(updatingPrimaryEventsOverrideFailed(error.errors))
    }
    )
  }
}

function updatingPrimaryEventsOverride(){
  return {
    type: OVERIDING_PRIMARY_EVENTS,
    payload: {}
  }
}

function updatingPrimaryEventsOverrideSucceeded(json) {
  return {
    type: OVERIDING_PRIMARY_EVENTS_SUCCEEDED,
    payload: json
  }
}

function updatingPrimaryEventsOverrideFailed(error){
  return {
    type: OVERIDING_PRIMARY_EVENTS_FAILED,
    payload: error
  }
}

export function fetchTotalSalesforceIntegrations() {
  
  return function (dispatch) {
    dispatch(fetchingTotalSalesforceIntegrations());
    return axios({
      method: 'GET',
      url: `${SALESFORCE_BASE_URL_V2}/total_count`
    })

      .then((response) => {
        dispatch(fetchingTotalSalesforceIntegrationsSucceeded(response.data));
      })
      .catch(error => {
        dispatch(fetchingTotalSalesforceIntegrationsFailed(error.errors))
    }
    )
  }
}

function fetchingTotalSalesforceIntegrations(){
  return {
    type: FETCHING_TOTAL_SALESFORCE_INTEGRATIONS,
    payload: {}
  }
}

function fetchingTotalSalesforceIntegrationsSucceeded(response) {
  return {
    type: FETCHING_TOTAL_SALESFORCE_INTEGRATIONS_SUCCEEDED,
    payload: response
  }
}

function fetchingTotalSalesforceIntegrationsFailed(error){
  return {
    type: FETCHING_TOTAL_SALESFORCE_INTEGRATIONS_FAILED,
    payload: error
  }
}